export default "__VITE_ASSET__5a14b320__"